module.exports = __webpack_public_path__ + "images/78be32832b338d180a8c89c46ecd4477.png";